import { render, staticRenderFns } from "./OrderBottom.vue?vue&type=template&id=c0139a3a&"
import script from "./OrderBottom.vue?vue&type=script&lang=ts&"
export * from "./OrderBottom.vue?vue&type=script&lang=ts&"
import style0 from "./OrderBottom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports